import { dynamicWrapper, createRoute } from '@/utils/core';

const routesConfig = app => ({
  path: '/car/addcar',
  title: '社会车辆入库',
  component: dynamicWrapper(app, [import('./model')], () => import('./components'))
});

export default app => createRoute(app, routesConfig);
